export default __webpack_public_path__ + "stumbler-phone@2x.dd5f5d9b.png";